export default __webpack_public_path__ + "static/media/HiringProfile.4bc4db26.svg";